import { createContext } from 'react';

import type { TransitionType, AnimationState } from './types';

export const Context = createContext<{
  transition: TransitionType;
  state: AnimationState;
}>({
  transition: 'fade',
  state: 'entering',
});
